import type { FetcherOptions } from "@/modules/fetch/types"

import { getCookie } from "@/modules/client/cookies/getCookies"
import { generateCommonHeadersFromOptions } from "@/modules/fetch/generateCommonHeadersFromOptions"
import { DEFAULT_LOCALE } from "@/modules/locales/constants"
import { getLocaleFromPathname } from "@/modules/request/helpers/getLocaleFromPathname"
import { TALENT_CONNECT_SESSION_COOKIE_NAME } from "@/modules/talentConnect/constants"

export const generateClientHeaders = (options: FetcherOptions): HeadersInit => {
  const locale = getLocaleFromPathname(window.location.pathname) || DEFAULT_LOCALE
  const commonHeaders = generateCommonHeadersFromOptions(options)
  const clientHeaders: HeadersInit = {}

  if (options.withTalentConnectUserSession) {
    const talentConnectSession = getCookie(TALENT_CONNECT_SESSION_COOKIE_NAME)

    if (talentConnectSession) {
      clientHeaders.Authorization = `Bearer ${talentConnectSession}`
    }
  }

  const headers = {
    ...commonHeaders,
    ...clientHeaders,
    "Accept-Language": locale,
    "jt-source-service": "next-jobteaser-client",
  }

  return headers
}
